/*
  BB Sticky Add-to-Cart (mobile) — companion to snippets/bb-sticky-atc.liquid.

  Horizon's sticky bar logic stays in charge (show after the buy buttons, sync with the variant,
  add to cart). This module only:
    · pins the bar (data-bb-pinned) while the buy buttons are above the viewport and the footer
      has not yet entered it — Horizon itself hides it as soon as the footer is 200px away;
    · mirrors the selected variant title into data-bb-variant so CSS can show "S · AED 284".
*/
const bar = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar');
const buyButtons = document.querySelector('.buy-buttons-block');
const footer = document.querySelector('.shopify-section-group-footer-group') ?? document.querySelector('footer');

if (bar && buyButtons) {
  let pastBuyButtons = false;
  let footerInView = false;
  const update = () => {
    bar.dataset.bbPinned = String(pastBuyButtons && !footerInView);
  };

  new IntersectionObserver(([entry]) => {
    if (!entry) return;
    pastBuyButtons = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    update();
  }).observe(buyButtons);

  if (footer) {
    new IntersectionObserver(([entry]) => {
      if (!entry) return;
      footerInView = entry.isIntersecting;
      update();
    }).observe(footer);
  }

  const price = bar.querySelector('.sticky-add-to-cart__price');
  const variant = bar.querySelector('.sticky-add-to-cart__variant');
  const syncVariant = () => {
    if (!price) return;
    const hidden = !variant || variant.style.display === 'none';
    const title = hidden ? '' : variant.textContent.trim();
    price.dataset.bbVariant = title ? `${title} ·` : '';
  };
  syncVariant();
  if (variant) new MutationObserver(syncVariant).observe(variant, { childList: true, characterData: true, subtree: true, attributes: true });
}
